export const PHONE_COUNTRY_CODES = [
  { code: '+39', flag: '🇮🇹', name: 'Italia' },
  { code: '+33', flag: '🇫🇷', name: 'Francia' },
  { code: '+49', flag: '🇩🇪', name: 'Germania' },
  { code: '+44', flag: '🇬🇧', name: 'Regno Unito' },
  { code: '+34', flag: '🇪🇸', name: 'Spagna' },
  { code: '+41', flag: '🇨🇭', name: 'Svizzera' },
  { code: '+43', flag: '🇦🇹', name: 'Austria' },
  { code: '+32', flag: '🇧🇪', name: 'Belgio' },
  { code: '+31', flag: '🇳🇱', name: 'Paesi Bassi' },
  { code: '+351', flag: '🇵🇹', name: 'Portogallo' },
  { code: '+30', flag: '🇬🇷', name: 'Grecia' },
  { code: '+353', flag: '🇮🇪', name: 'Irlanda' },
  { code: '+352', flag: '🇱🇺', name: 'Lussemburgo' },
  { code: '+377', flag: '🇲🇨', name: 'Monaco' },
  { code: '+378', flag: '🇸🇲', name: 'San Marino' },
  { code: '+379', flag: '🇻🇦', name: 'Città del Vaticano' },
  { code: '+385', flag: '🇭🇷', name: 'Croazia' },
  { code: '+386', flag: '🇸🇮', name: 'Slovenia' },
  { code: '+48', flag: '🇵🇱', name: 'Polonia' },
  { code: '+40', flag: '🇷🇴', name: 'Romania' },
  { code: '+90', flag: '🇹🇷', name: 'Turchia' },
  { code: '+7', flag: '🇷🇺', name: 'Russia' },
  { code: '+1', flag: '🇺🇸', name: 'Stati Uniti / Canada' },
  { code: '+55', flag: '🇧🇷', name: 'Brasile' },
  { code: '+86', flag: '🇨🇳', name: 'Cina' },
  { code: '+81', flag: '🇯🇵', name: 'Giappone' },
  { code: '+971', flag: '🇦🇪', name: 'Emirati Arabi Uniti' },
  { code: '+61', flag: '🇦🇺', name: 'Australia' },
];

export const DEFAULT_PHONE_PREFIX = '+39';

// Divide un numero salvato (es. "+39 333 1234567") in prefisso + resto,
// riconoscendo il prefisso più lungo/specifico per evitare ambiguità
// (es. "+39..." non deve essere letto come "+3" di un altro paese).
export const splitPhone = (value) => {
  const v = String(value || '').trim();
  if (!v) return { prefix: DEFAULT_PHONE_PREFIX, number: '' };
  const sorted = [...PHONE_COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);
  const match = sorted.find((c) => v.startsWith(c.code));
  if (match) {
    return { prefix: match.code, number: v.slice(match.code.length).trim() };
  }
  return { prefix: DEFAULT_PHONE_PREFIX, number: v };
};

// Ricompone prefisso + numero locale in un'unica stringa da salvare.
// Se il numero è vuoto, il telefono resta vuoto (campo opzionale).
export const combinePhone = (prefix, number) => {
  const n = String(number || '').trim();
  return n ? `${prefix} ${n}` : '';
};
